/* eslint-env browser, jquery */
import 'bootstrap';
import container from 'modules/section-content';
import domify from 'domify';
import page from 'modules/ab-page-js';
import scrollIntoView from 'scroll-into-view';
import axios from 'axios';
import AnimationScroll from 'modules/animation-scroll';
import { assign, pick } from 'lodash';
import splash from './ambassador-program.pug';
import metadata from './metadata.json';

const animationScroll = new AnimationScroll();

const FORM_SELECTOR = 'form.apply-form';
const BUTTON_SELECTOR = `${FORM_SELECTOR} button`;
const FIELDS_SELECTOR = `${FORM_SELECTOR} input, ${FORM_SELECTOR} textarea`;

let ambassadors;
let ambassadorsMonth;
let ambassadorsWinners;
let winnersDate;

function fecthAmbassadors(ctx, next) {
  axios.get(`/ambassador-program/api/data`).then(response => {
    ambassadors = response.data.ambassadors;
    ambassadorsMonth = response.data.ambassadorsMonth;
    ambassadorsWinners = response.data.ambassadorsWinners;
    winnersDate = response.data.winnersDate;
    next();
  });
}

export default function register() {
  page('/ambassador-program', fecthAmbassadors, render, snippets);
  page.exit('/ambassador-program', resetAnimation);
}

function render(ctx, next) {
  const renderOptions = {
    metadata,
    // Only pass view on client render.
    ...(ctx.init
      ? {}
      : {
          view: domify(
            splash({
              ambassadors,
              ambassadorsMonth,
              ambassadorsWinners,
              winnersDate
            })
          )
        })
  };
  container.render(renderOptions);

  next();
}

function snippets(ctx, next) {
  setupClickHandlers();
  setupContactForm();

  $('.form-apply').on('click', () => {
    scrollAnimated($('#form-apply').offset().top, 600);
  });

  next();
}

function setupClickHandlers() {
  const ourGoalTargetElem = document.getElementById('scroll-spy-our-goal');
  const ambassadorMonthTargetElem = document.getElementById('scroll-spy-ambassador-month');
  const canITargetElem = document.getElementById('scroll-spy-can-i');
  const rewardsTargetElem = document.getElementById('scroll-spy-rewards');
  const notAloneTargetElem = document.getElementById('scroll-spy-not-alone');

  const $ourGoalSection = $('.ambassador-program section[role="navigation"] .section-our-goal');
  const $ambassadorMonthSection = $(
    '.ambassador-program section[role="navigation"] .section-ambassador-month'
  );
  const $canISection = $('.ambassador-program section[role="navigation"] .section-can-i');
  const $rewardsSection = $('.ambassador-program section[role="navigation"] .section-rewards');
  const $notAloneSection = $('.ambassador-program section[role="navigation"] .section-not-alone');

  $ourGoalSection.on('click', () => scrollIntoView(ourGoalTargetElem, { time: 500 }));
  $ambassadorMonthSection.click(() => scrollIntoView(ambassadorMonthTargetElem, { time: 500 }));
  $canISection.click(() => scrollIntoView(canITargetElem, { time: 500 }));
  $rewardsSection.click(() => scrollIntoView(rewardsTargetElem, { time: 500 }));
  $notAloneSection.click(() => scrollIntoView(notAloneTargetElem, { time: 500 }));
}

function easeInOut(currentTime, startValue, change, duration) {
  let currentTimeTmp = currentTime / duration * 2;

  if (currentTimeTmp < 1) {
    return change / 2 * currentTimeTmp * currentTimeTmp + startValue;
  }

  currentTimeTmp -= 1;

  return -change / 2 * (currentTimeTmp * (currentTimeTmp - 2) - 1) + startValue;
}

function scrollAnimated(to, duration) {
  const start = $(window).scrollTop();
  const change = to - start;
  const increment = 20;
  let currentTime = 0;

  function animateScroll() {
    currentTime += increment;

    const val = easeInOut(currentTime, start, change, duration);

    $(window).scrollTop(val);

    if (currentTime < duration) {
      setTimeout(animateScroll, increment);
    }
  }

  animateScroll();
}

function setupContactForm() {
  $(FORM_SELECTOR).submit(sendForm);
}

function sendForm(e) {
  e.preventDefault();

  const $button = $(BUTTON_SELECTOR);

  if (
    $button.hasClass('success') ||
    $button.hasClass('btn-danger') ||
    $button.hasClass('btn-loading')
  ) {
    return undefined;
  }
  setSubmitButtonState($button, 'process');
  const bodyFields = ['name', 'email', 'message'];
  const dataFields = ['country', 'city-province', 'link'];
  const fields = $(FIELDS_SELECTOR)
    .toArray()
    .reduce((result, current) => {
      result[current.name] = current.value;
      return result;
    }, {});

  const initial = {
    source: 'ambassador-program',
    subject: `Ambassador program contact from ${fields.name}`
  };

  const body = assign(initial, pick(fields, bodyFields), { data: pick(fields, dataFields) });
  return $.post(
    'https://wt-139739a316b9b05b2ef2d61c5ed80be7-0.sandbox.auth0-extend.com/contact-form',
    body
  )
    .done(() => setSubmitButtonState($button, 'success'))
    .fail(() => setSubmitButtonState($button, 'error'))
    .always(
      () =>
        setTimeout(() =>
          $(FIELDS_SELECTOR).each((idx, field) => {
            field.value = '';
          })
        ),
      3000
    );
}

function resetAnimation(ctx, next) {
  animationScroll.reset();
  next();
}

function setSubmitButtonState(submitButton, state) {
  switch (state) {
    case 'success':
      submitButton
        .removeClass('btn-danger shake btn-loading')
        .addClass('btn-success success tada')
        .html('<span aria-hidden="true" class="btn-icon icon-budicon-390"></span> Sent');
      setTimeout(() => setSubmitButtonState(submitButton, 'initial'), 3000);
      break;

    case 'error':
      submitButton
        .removeClass('btn-success success btn-loading tada')
        .addClass('btn-danger shake')
        .html('<span aria-hidden="true" class="btn-icon icon-budicon-389"></span> Error');
      setTimeout(() => setSubmitButtonState(submitButton, 'initial'), 2000);
      break;

    case 'process':
      submitButton
        .removeClass('success btn-danger')
        .addClass('btn-loading')
        .html('<span aria-hidden="true" class="icon-rotating icon-budicon-330"></span>');
      break;

    default:
      submitButton
        .removeClass('success btn-danger btn-loading tada shake')
        .addClass('btn-success')
        .html('APPLY');
  }
}



// WEBPACK FOOTER //
// ./src/pages/ambassador-program/ambassador-program.js